import { Injectable } from '@angular/core';
import { GSA } from '../models/gsa.model';

@Injectable({
    providedIn: 'root'
})
export class MarginCalculatorStipendsService {
    getMaxHousing(value: GSA): number {
        return value ? (value.lodgingRatePerDay || 0) * 7 : 0;
    }

    getMaxMeals(value: GSA): number {
        return value ? (value.mealRatePerDay || 0) * 7 : 0;
    }
}
